import axios from "axios";
import Swal from "sweetalert2";

// Production-д REACT_APP_API_URL env var-аар өөр хаяг өгч болно.
// Локал dev-ийн үед .env.local-аас "http://10.111.5.127:8083" гэх мэт зааж болно.
const BASE_URL =
  process.env.REACT_APP_API_URL || "https://hse.erdenetmc.mn/api";

export function API() {
  const headers = {
    "Content-Type": "application/json,",
  };
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;
  if (token != null) {
    Object.assign(headers, {
      Authorization: "SSO " + token,
    });
  }
  const api = axios.create({
    baseURL: BASE_URL,
    timeout: 200000,
    headers,
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error === undefined || error.response === undefined) {
        console.log(error);
        Swal.fire({
          title: "Сервистэй холбогдсонгүй.",
          icon: "error",
          // timer: 3000,
        });
      } else {
        if (error.response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("menuID");
          localStorage.removeItem("menuName");
          window.location.replace("/");
        }
      }
      throw error;
    },
  );
  return api;
}

export async function get(url, params) {
  const response = await API().get(url, {
    params: {
      ...params,
    },
  });
  return response.data;
}

export async function post(url, params) {
  const response = await API().post(url, {
    ...params,
  });
  return response.data;
}

export async function put(url, params) {
  const response = await API().put(url, {
    ...params,
  });
  return response.data;
}

export async function _delete(url, params) {
  const response = await API().get(url, {
    params: {
      ...params,
    },
  });
  return response.data;
}

export async function getUserInfo() {
  const response = await API().get("/user/info");
  return response.data;
}

export async function getAuth() {
  const response = await API().get("/auth");
  return response;
}
export async function postAuth(params) {
  const response = await API().post("/auth", { ...params });
  return response;
}

export async function changeUser(params) {
  const response = await API().post("/user/change", { ...params });
  return response.data;
}

export async function logOut() {
  const response = await API().get("/logout");
  return response;
}

export async function getDepartments() {
  const response = await API().get("/daily/department");
  return response.data;
}

export async function getDepartmentPosition(department) {
  const response = await API().get(
    "/daily/department/" + department + "/position",
  );
  return response.data;
}

export async function getEmployeeSearch(param) {
  const response = await API().get("/worker/search/" + param);
  return response.data;
}

// Ажилтны бүртгэлийн дугаараар (tn) мэдээллийг wr_workers-аас татах
export async function getWorkerByTn(tn) {
  const response = await API().get("/worker/" + tn);
  return response.data;
}

// ---------------------Нормын тоо -----

export async function getNorm(params) {
  const response = await API().get("/xx/report/norm", {
    params: { ...params },
  });
  return response.data;
}

export async function getNormWorker(params) {
  const response = await API().get("/xx/report/norm/item/worker", {
    params: { ...params },
  });
  return response.data;
}

export async function getItemsPrice(params) {
  const response = await API().get("/xx/report/requirement/price", {
    params: { ...params },
  });
  return response.data;
}

//-------------------------------

export async function getEmployeeLesson() {
  const response = await API().get("/employee/training");
  return response.data;
}

export async function getEmployeeTraining() {
  const response = await API().get("/employee/lesson");
  return response.data;
}

// Жилийн сургалтын ТӨЛӨВЛӨГӨӨНД байгаа ч ажилтан хараахан СУУГААГҮЙ
// сургалтууд + тэдгээрийн хуваарь (training.PlanWorker ↔ Register).
export async function getEmployeeTrainingPlan(year) {
  const response = await API().get("/employee/training/plan", {
    params: year ? { year } : {},
  });
  return response.data;
}

export async function getDailyRegisterInterval() {
  const response = await API().get("/daily/interval");
  return response.data;
}

export async function getDailyRegisterShift() {
  const response = await API().get("/daily/shift");
  return response.data;
}

export async function getDailyRegisterList(params) {
  const response = await API().get("/daily/questionlist", {
    params: {
      intervalid: params.intervalid,
      registermonth: params.registermonth,
    },
  });
  return response.data;
}

export async function getDailyRegister(registerdate, intervalid) {
  const response = await API().get("/daily/register", {
    params: {
      registerdate: registerdate,
      intervalid: intervalid,
    },
  });
  return response.data;
}

export async function postDailyRegister(params) {
  const response = await API().post("/daily/register", {
    id: params.id,
    intervalid: params.intervalid,
    questionid: params.questionid,
    registerdate: params.registerdate,
    shiftid: params.shiftid === null ? 1 : params.shiftid,
  });
  return response.data;
}

export async function getDailyRegisterSub(registerID) {
  const response = await API().get("/daily/registersublist/" + registerID);
  return response.data;
}

export async function postDailyRegisterSub(params) {
  const response = await API().post("/daily/registersub", {
    id: params.id,
    registerid: params.registerid,
    registerdate: params.registerdate,
    questionpoint: params.questionpoint,
    questiondesc: params.questiondesc === null ? "" : params.questiondesc,
  });
  return response.data;
}

export async function deleteDailyRegisterSub(id) {
  const response = await API().delete("/daily/registersub/" + id);
  return response.data;
}

export async function getDailyRegisterReport(startdate, enddate) {
  const response = await API().get("/daily/questionreport", {
    params: {
      startdate: startdate,
      enddate: enddate,
    },
  });
  return response.data;
}
// ------------ REFERENCE ---------------------
export async function getDailyQuestion() {
  const response = await API().get("/daily/question");
  return response.data;
}

export async function getDailyQuestionGroup(params) {
  const response = await API().get("/daily/question/group", {
    params: { workergroup: params.workergroup, intervalid: params.intervalid },
  });
  return response.data;
}

export async function postDailyQuestionGroup(params) {
  const response = await API().post("/daily/question/group", {
    workergroup: params.workergroup,
    intervalid: params.intervalid,
    questionid: params.questionid,
    ischeck: params.ischeck,
  });
  return response.data;
}

export async function getDailyModule() {
  const response = await API().get("/daily/module");
  return response.data;
}

export async function getRateInterval() {
  const response = await API().get("/daily/rateinterval");
  return response.data;
}

export async function getRateReferenceQuestionConn(params) {
  const response = await API().get("/daily/rate/position", {
    params: {
      ...params,
    },
  });
  return response.data;
}

export async function postRateReferenceQuestionConn(params) {
  const response = await API().post("/daily/rate/position", {
    ...params,
  });
  return response.data;
}

export async function getRateList(year, intervalID) {
  const response = await API().get("/daily/rate/list", {
    params: {
      intervalyear: year,
      intervalid: intervalID,
    },
  });
  return response.data;
}

export async function getRateQuestion(params) {
  const response = await API().get("/daily/rate", {
    params: {
      ...params,
    },
  });
  return response.data;
}

export async function postRateQuestion(params) {
  const response = await API().post("/daily/rate", {
    ...params,
  });
  return response.data;
}

/**
 * Хэрэглэгчийн эрхээр шүүгдсэн бүтцийн нэгжийн жагсаалт.
 *
 * @param stage — сонголттой. "IV" гэж өгвөл 4 дүгээр шатны хяналтын
 *   хамрах хүрээ (үйлдвэрийн БҮХ нэгж) хүсэгдэнэ. Backend нь
 *   `inspection_IV_add` эрхтэй хүнд Л өргөснө, тиймээс параметрийг
 *   гараар засаж эрх авах боломжгүй. Параметргүй дуудвал хуучин
 *   (нэгжээр хумигдсан) ажиллагаа хэвээр — бусад 20 дуудагч
 *   нөлөөлөхгүй.
 */
/* ── КЭШ (2026-10-16) ────────────────────────────────────────────────
   ⚠ АСУУДАЛ (хэмжсэн): `getUserDepartment` нь 46 файлаас дуудагддаг ба
     кэш БАЙГААГҮЙ. Сонгогч бүр mount болохдоо шинээр татдаг тул
     /inspection/xab нэг нээхэд 4 УДАА, /risk/list ба /risk/plan дээр
     2 удаа явдаг.
   ⚠ 2026-10-15-нд `/user/department` нь IV шатны эрхтэнд БҮХ нэгжийг
     буцаадаг болсон (4 нэгж → 456 нэгж, 0.15 MB). Дуудлагын тоо ×
     хариуны хэмжээ хоёулаа өссөн тул pod-ын 16 оролт дүүрч, бусад
     хүсэлт 200 СЕКУНД хүлээгээд уначихдаг болов — «өчигдрөөс эхэлсэн»
     гацалт яг үүнээс.
   ⚠ PROMISE-ЫГ кэшилнэ, үр дүнг БИШ: зэрэг mount болсон 4 сонгогч
     нэг л хүсэлт хуваалцана (үр дүнг кэшилбэл 4-үүлээ зэрэг явчихна).
   ⚠ `stage` тус бүрд ТУСДАА түлхүүр — IV шат өөр жагсаалт авдаг.
   ⚠ Сешн дотор өөрчлөгддөггүй ЛАВЛАХ дата тул хугацаа тавиагүй.
     Хэрэглэгч солигдоход хуудас бүхэлдээ дахин ачаалагддаг. */
const _deptCache = new Map();

export async function getUserDepartment(stage) {
  const key = stage ? String(stage) : "";
  if (!_deptCache.has(key)) {
    _deptCache.set(
      key,
      API()
        .get("/user/department" + (key ? "?stage=" + encodeURIComponent(key) : ""))
        .then((r) => r.data)
        .catch((e) => {
          // ⚠ Алдааг кэшлэхгүй — түр зуурын тасалдлын дараа дахин
          //   оролдох боломжтой байх ёстой.
          _deptCache.delete(key);
          throw e;
        }),
    );
  }
  return _deptCache.get(key);
}

export async function getSearchWorkerList(tn) {
  const response = await API().get("/employee/" + tn);
  return response.data;
}

/**
 * БН (цех) / хэсгээр ИДЭВХТЭЙ ажилтны жагсаалт.
 *
 * @param {{tseh_code?: string, negj_code?: string}} params
 *        Хоёрын НЭГ нь заавал байна — эс бөгөөс backend 400 буцаана
 *        (бүх ажилтныг дуудахаас сэргийлсэн).
 * @returns {Promise<Array<{tn, shortname, position_namemn, tseh_code,
 *          tseh_namemn, negj_code, negj_namemn}>>}
 *
 * Хамрах хүрээ backend дээр `userzone`-оор шүүгддэг тул эрхээс гадуурх
 * нэгжийн ажилтан буцахгүй.
 */
export async function getWorkerListByUnit(params) {
  const response = await API().get("/worker/list", { params });
  return response.data;
}

// ---------------Ажилтнуудын биеийн размер ----------------

export async function getEmployeeNorm(tn) {
  const response = await API().get("/xx/employee/" + tn + "/norm");
  return response.data;
}

export async function getEmployeeSizeList(params) {
  const response = await API().get("/xx/employee/size", {
    params: {
      departmentid: params.departmentid,
    },
  });
  return response.data;
}
export async function getEmployeeHeight(tn) {
  const response = await API().get("/xx/employee/size/" + tn);
  return response.data;
}
export async function postEmployeeSize(params) {
  const response = await API().post("/xx/employee/size", { ...params });
  return response.data;
}

export async function getEmployeeItemSize(params) {
  const response = await API().get("/xx/employee/item/size", {
    params: {
      ...params,
    },
  });
  return response.data;
}
export async function postEmployeeItemSize(params) {
  const response = await API().post("/xx/employee/item/size", { ...params });
  return response.data;
}

//------------------------Тайлан ---------------------------

export async function getReport1(params) {
  const response = await API().get("/xx/dashboard/norm", {
    params: {
      year: params.year,
    },
  });
  return response.data;
}

export async function getReportALLItemSize(params) {
  const response = await API().get("/xx/report/requirement/item/size/month", {
    params: {
      ...params,
    },
  });
  return response.data;
}
export async function getWorkerNorm() {
  const response = await API().get("xx/dashboard/norm/worker/count");
  return response.data;
}

export async function getReport1OstatokRashod(itemid) {
  const response = await API().get("/xx/dashboard/norm/detail/" + itemid);
  return response.data;
}
export async function getReport1NotGiving(itemid) {
  const response = await API().get("/xx/dashboard/norm/notgiving/" + itemid);
  return response.data;
}
export async function getReport1NormEmpty() {
  const response = await API().get("/xx/dashboard/norm/empty");
  return response.data;
}
export async function getPlanDashboard(params) {
  const response = await API().get("xx/dashboard/norm/report", {
    params: { ...params },
  });
  return response.data;
}
export async function getPlanDashboardByDepartment(itemid, params) {
  const response = await API().get(
    "xx/dashboard/norm/report/detail/" + itemid + "?year=2023&month=1",
    {
      params: { ...params },
    },
  );
  return response.data;
}
export async function getPlanDashboardByDepartment1(depid, params) {
  const response = await API().get(
    "xx/dashboard/norm/department/report/detail/" +
      depid +
      "?year=2023&month=1",
  );
  //   {
  //     params: { ...params },
  //   }
  // );
  return response.data;
}
export async function getRemainder(depid, params) {
  const response = await API().get("/xx/dashboard/norm/remainder");
  //   {
  //     params: { ...params },
  //   }
  // );
  return response.data;
}
export async function getDashboardByDepartmentRequirement(params) {
  const response = await API().get("/xx/report/department/requirement", {
    params: { ...params },
  });
  return response.data;
}
export async function getDashboardByDepartmentRequirementWorker(params) {
  const response = await API().get("/xx/report/department/requirement/worker", {
    params: { ...params },
  });
  return response.data;
}
export async function getDashboardByDepartmentItemWorker(params) {
  const response = await API().get("/xx/report/department/item/worker", {
    params: { ...params },
  });
  return response.data;
}
export async function getDashboardByDepartmentItemSize(params) {
  const response = await API().get(
    "xx/report/requirement/item/tseh/size/month",
    {
      params: { ...params },
    },
  );
  return response.data;
}
export async function getDashboardByDepartmentItems(params) {
  const response = await API().get("xx/report/requirement/item/tseh/month", {
    params: { ...params },
  });
  return response.data;
}
export async function getDashboardAllItems(params) {
  const response = await API().get("/xx/report/requirement/year", {
    params: { ...params },
  });
  return response.data;
}

//------------------------Эрсдэлийн үнэлгээ ---------------------------

export async function postWorkService(params) {
  const response = await API().post("/risk/assessment", { ...params });
  return response;
}

export async function riskDashboard(date) {
  const response = await API().get("/risk/assessment/" + date);
  return response.data;
}

export async function riskStage() {
  const response = await API().get("/risk/reference/stage", {
    type_id: 6,
    operation_name: "name",
    operation_risk: "risk",
    // params: {
    //   year: year,
    //   category: category,
    //   limit: limit,
    //   department_id: department,
    // },
  });
  return response.data;
}

export async function riskCategory() {
  const response = await API().get("/risk/reference/category", {
    type_id: 6,
    operation_name: "name",
    operation_risk: "risk",
  });
  return response.data;
}

export async function riskDepts() {
  const response = await API().get("/risk/reference/departments", {
    type_id: 6,
    operation_name: "name",
    operation_risk: "risk",
  });
  return response.data;
}

export async function riskType() {
  const response = await API().get("/risk/reference/type");
  return response.data;
}

export async function getRiskWorkservice(id, params) {
  const response = await API().get("/risk/assessments/" + id, {
    type_id: 6,
    operation_name: "name",
    operation_risk: "risk",
    params: {
      ...params,
    },
  });

  return response.data;
}
export async function riskSubDepts(id) {
  const response = await API().get("/risk/reference/departments/sub/" + id, {
    type_id: 6,
    operation_name: "name",
    operation_risk: "risk",
  });
  return response.data;
}

export async function riskMatrixSequences() {
  const response = await API().get("/risk/matrix/consequences");
  return response.data;
}

export async function riskMatriProbabilities() {
  const response = await API().get("/risk/matrix/probabilities");
  return response.data;
}

// Лавлах сан
export async function getRiskReferenceType() {
  const response = await API().get("/risk/reference/type");
  return response.data;
}
export async function getRiskReferenceTypeId(id) {
  const response = await API().get("/risk/reference/type/" + id);
  return response.data;
}
export async function postRiskReferenceType(json) {
  const response = await API().post("/risk/reference/type", { ...json });
  return response.data;
}
export async function deleteRiskReferenceType(id) {
  const response = await API().delete("/risk/reference/type/" + id);
  return response.data;
}
export async function putRiskReferenceType(id, json) {
  const response = await API().put("/risk/reference/type/" + id, { ...json });
  return response;
}

export async function getRiskFactor() {
  const response = await API().get("/risk/reference/threat");
  return response.data;
}

export async function getThreatType() {
  const response = await API().get("/risk/reference/threat/type");
  return response.data;
}
export async function postReferenceThreat(pid, json) {
  const response = await API().post("/risk/reference/threat/" + pid, {
    ...json,
  });
  return response.data;
}
export async function getReferenceThreat() {
  const response = await API().get("/risk/reference/threat");
  return response.data;
}
export async function putReferenceThreat(id, json) {
  const response = await API().put("/risk/reference/threat/" + id, { ...json });
  return response.data;
}
export async function deleteReferenceThreat(id) {
  const response = await API().delete("/risk/reference/threat/" + id);
  return response.data;
}
export async function postReferenceThreatType(json) {
  const response = await API().post("/risk/reference/threat/type", { ...json });
  return response.data;
}
export async function putReferenceThreatType(id, json) {
  const response = await API().put("/risk/reference/threat/type/" + id, {
    ...json,
  });
  return response.data;
}
export async function deleteReferenceThreatType(id) {
  const response = await API().delete("/risk/reference/threat/type/" + id);
  return response.data;
}
export async function getReferenceOperation() {
  const response = await API().get("/risk/reference/operation");
  return response.data;
}

export async function getMatrix() {
  const response = await API().get("/risk/matrix");
  return response.data;
}
export async function getMatrixEqui(consequence_id, probability_id) {
  const response = await API().get(
    "/risk/matrix/" + consequence_id + "/" + probability_id,
  );
  return response.data;
}

export async function patchReferenceOperationMatrix(id, json) {
  const response = await API().patch("/risk/reference/operation/" + id, {
    ...json,
  });
  return response.data;
}

export async function postReferenceOperation(json) {
  const response = await API().post("/risk/reference/operation", { ...json });
  return response.data;
}
export async function getReferenceOperationType(id) {
  const response = await API().get("/risk/reference/operation/" + id);
  return response.data;
}
export async function putReferenceOperation(id, json) {
  const response = await API().put("/risk/reference/operation/" + id, {
    ...json,
  });
  return response.data;
}
export async function deleteReferenceOperation(id) {
  const response = await API().delete("/risk/reference/operation/" + id);
  return response.data;
}
export async function getReferenceMeasure() {
  const response = await API().get("/risk/reference/measure");
  return response.data;
}

export async function getMatrixProb() {
  const response = await API().get("risk/matrix/probabilities");
  return response.data;
}
export async function getMatrixConseq() {
  const response = await API().get("risk/matrix/consequences");
  return response.data;
}

export async function getReferenceOperationMeasure(id, measure_id) {
  const response = await API().get(
    "risk/reference/operation/" + id + "/measure/" + measure_id,
  );
  return response.data;
}

export async function postReferenceOperationMeasure(id) {
  const response = await API().post(
    "risk/reference/operation/" + id + "/measure",
  );
  return response.data;
}
// export async function postPlan(params) {
//   const response = await API().get("/xx/plan/item", { ...params });
//   return response.data;
// }
// export async function putPlan(params) {
//   const response = await API().post("/xx/plan/item", { ...params });
//   return response.data;
// }

// export async function putPlan(params) {
//   const response = await API().put("/xx/plan/item", { ...params });
//   return response.data;
// }
//----------------------office norm -------------------------------------
export async function getOfficePosition(params) {
  const response = await API().get("xx/office/position", {
    params: {
      ...params,
    },
  });
  return response.data;
}
export async function getOfficeNorm(params) {
  const response = await API().get("xx/office/norm/list", {
    params: {
      ...params,
    },
  });
  return response.data;
}
export async function postOfficeNorm(params) {
  const response = await API().post("xx/office/norm", { ...params });
  return response.data;
}
export async function postOfficeNormCopy(params) {
  const response = await API().post("xx/office/norm/copy", { ...params });
  return response.data;
}
export async function getOfficeNormDetail(params) {
  const response = await API().get("xx/office/norm/list", {
    params: {
      ...params,
    },
  });
  return response.data;
}
